<template>
  <b-sidebar id="restaurant-comments" bg-variant="transparent" width="400px"
             class="text-dark" no-header backdrop>

    <b-row id="scroll" class="comment d-flex flex-row justify-content-center">
      <b-col cols="12" class="d-flex flex-column align-items-center">
        <b-row class="d-flex flex-row justify-content-start align-items-start p-3 w-100">
          <b-button variant="transparent" v-b-toggle.restaurant-comments>
            <b-icon variant="transparent" class="text-dark" icon="x"/>
          </b-button>
        </b-row>
        <b-row class="d-flex flex-row justify-content-center align-items-center p-3 w-100">
          <h5 class="comment-title">رستوران : {{ restaurant_name }}</h5>
        </b-row>

        <b-row class="w-100" v-for="comment in comments" :key="comment.id">

          <b-col class="d-flex flex-column align-items-center">

            <b-row class="d-flex flex-row align-items-start w-100">
              <h4 class="secondary-text">{{ comment.user.name + ' ' + comment.user.last_name }}</h4>
              <b-col cols="4" class="d-flex flex-row justify-content-center">
                <div class="justify-center" v-for="i in 5" :key="i">
                  <b-icon icon="star-fill" font-scale=".75" variant="warning" v-if="i<=comment.rate"/>
                  <b-icon icon="star" font-scale=".75" variant="warning" v-else/>
                </div>
              </b-col>
            </b-row>

            <b-row class="d-flex flex-row align-items-center">
              <b-col cols="12">
                <p class="h4 text-2" v-html="comment.body"/>
              </b-col>

              <!--                <b-col lg="12" class="text-center">
                                <router-link :to="{name:'Products'}">
                                  <b-button v-for="food in 7" :key="food" pill
                                            class="m-1 px-3 animation-shadow stand-up-animation text-dark foods-on-comment" size="sm">
                                    کباب
                                  </b-button>
                                </router-link>
                              </b-col>-->

            </b-row>
            <b-row class="d-flex flex-row justify-content-center w-100">
              <hr>
            </b-row>

          </b-col>
        </b-row>

      </b-col>

      <b-row class="w-100 d-flex flex-row justify-content-center" v-if="comments.length===0">
        <span class="text-dark">هیچ نظری ثبت نشده است</span>
      </b-row>

      <b-row class="d-flex flex-row justify-content-center w-100">
        <b-col class="d-flex flex-column align-items-center">
          <b-button v-b-modal.add-comment-restaurant pill class="comment-form  animation-shadow stand-up-animation"
                    @click="setCommentableId">شما
            هم نظر خود را ثبت کنید
          </b-button>
        </b-col>
      </b-row>
    </b-row>

    <m-pagination-400 class="pb-5" :meta="meta" :on-change-page="changeCommentPage"/>

    <b-modal id="add-comment-restaurant" centered hide-header-close
             title="ثبت نظر برای رستوران" @ok="onSubmit" @cancel="resetCommentForm">

      <form @submit.stop.prevent="onSubmit">

        <form-group :validations="$v.commentForm.body">
          <div slot-scope="{ errors, invalid }">
            <vue-editor class="dir-rtl text-right text-dark" placeholder="نظر خود را بنویسید"
                        v-model="commentForm.body" :editorToolbar="customToolbar"/>
            <form-errors-manager :errors="errors"/>
          </div>
        </form-group>

        <b-col cols="12" class="d-flex flex-column align-items-center justify-content-center p-3">
          <star-rating v-model="commentForm.rate" class="rate-s"></star-rating>
        </b-col>

      </form>


      <template #modal-footer="{ ok, cancel}">
        <b-row class="d-flex flex-row justify-content-around w-100">
          <b-button size="sm" class="mt-3 rounded text-dark" variant="success" @click="ok()">ثبت</b-button>
          <b-button size="sm" class="mt-3 rounded text-light" variant="danger" @click="cancel()">انصراف</b-button>
        </b-row>
      </template>

    </b-modal>

  </b-sidebar>
</template>

<script>
import {VueEditor} from "vue2-editor";
import FormGroup from "@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormGroup";
import {required} from "vuelidate/lib/validators";
import FormErrorsManager
  from '@moeinmdn/mixitweb-front-classic-dashboard/src/plugin/components/validator/FormErrorsManager.vue';
import StarRating from 'vue-star-rating'
import {mapGetters} from "vuex";

export default {
  name: "C6Comments",
  components: {VueEditor, FormGroup, FormErrorsManager, StarRating},
  props: ['comments', 'restaurant_id', 'restaurant_name'],
  computed:{
    ...mapGetters({
      meta: "Comment/getMeta",
    })
  },
  data() {
    return {
      commentForm: {
        body: '',
        rate: 1,
        commentable_type: 'brand',
        commentable_id: ''
      },
      customToolbar: [
        ["bold", "italic", "underline"],
        [{list: "ordered"}, {list: "bullet"}],
        [
          {align: ""},
          {align: "center"},
          {align: "right"},
          {align: "justify"}
        ],
        [{color: []}]
      ]
    }
  },
  validations: {
    commentForm: {
      body: {required},
      rate: {required}
    },
  },
  methods: {
    setCommentableId() {
      this.commentForm.commentable_id = this.restaurant_id
    },
    createComment() {
      if (this.commentForm.rate === 0) {
        this.commentForm.rate = 1
      }
      this.$store.dispatch("Comment/createComment", this.commentForm)
    },
    resetCommentForm() {
      this.commentForm = {
        body: '',
        rate: 1,
        commentable_type: 'brand',
        commentable_id: ''
      }
    },
    invalid() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    onSubmit(bvModalEvent) {
      bvModalEvent.preventDefault()
      if (this.invalid()) {
        this.createComment()
        this.$nextTick(() => {
          this.$bvModal.hide('add-comment-restaurant')
          this.resetCommentForm()
        })
      }
    },
    changeCommentPage(page) {
      let form = {id: this.restaurant_id, comment_type: 'brand'}
      this.$store.dispatch("Comment/getClientComments", {form: form, page: page})
    },
  },
  mounted() {
    const boxes = document.querySelectorAll('#restaurant-comments .b-sidebar-body');
    boxes.forEach(box => {
      box.style.padding = '20px 0 20px 0';
      box.style.display = 'flex';
      box.style.flexDirection = 'column';
      box.style.alignItems = 'center';
      box.style.height = '100%';
      box.style.borderRadius = '0 40px 40px 0';
      box.style.margin = '20px 0 20px 0';
      box.style.backgroundColor = 'white';
    });
  }
}
</script>

<style>
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  background-color: #F5F5F5;

}

::-webkit-scrollbar {
  width: 12px;
  background-color: transparent;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: var(--secondary);
}
</style>

<style scoped>
.comment-form {
  position: fixed;
  bottom: 30px;
  border-radius: 18px;
  transition: all .3s ease-in-out;
  font-family: 'Avini', 'Vazir', sans-serif !important;
  background-color: var(--secondary) !important;
  border: none !important;
}

.comment-form:hover {
  background-color: var(--primary) !important;
  color: var(--dark) !important;
}

.comment {
  border-radius: 30px;
  background-color: #fdfdfd;
  width: 100%;
  height: max-content;

}

.close-side {
  background-color: transparent;
  border: none;
}

.close-side:hover {
  background-color: transparent;
  border: none;
}

.foods-on-comment {
  transition: all ease-in-out .3s;
  background-color: var(--primary) !important;
  color: var(--dark) !important;
  border: none !important;
}

.custom-font-size-for-comment-section {
  font-size: 20px;
}

hr {
  border: 1px solid grey;
  width: 80%;
}

.rate-s {
  height: 40px !important;
  width: max-content !important;
}

.comment-title {
  font-family: 'Avini', 'Vazir', sans-serif !important;
}

</style>